import { api } from "../api";
import { Gauge } from "../components/Strata";
import { Section, Spinner, msgs, plural, ruDate, useAsync } from "../components/common";

export function ThreadView({
  id,
  onOpenPerson,
}: {
  id: number;
  onOpenPerson: (id: number) => void;
}) {
  const { data, loading, error } = useAsync(() => api.thread(id), [id]);
  if (loading) return <Spinner />;
  if (error || !data) return <div className="notice">{error ?? "Обсуждение не найдено"}</div>;

  const { thread, messages, topics } = data;
  return (
    <>
      <div className="screen-head">
        <div className="rail">обсуждение #{thread.root_msg_id}</div>
        <h1 style={{ fontSize: 21 }}>{thread.title ?? "Обсуждение"}</h1>
        <p style={{ fontFamily: "var(--font-mono)", fontSize: 11 }}>
          {ruDate(thread.started_at)} · {msgs(thread.msg_count)} · {thread.participant_count} уч.
          {thread.quality != null && (
            <span style={{ marginLeft: 8, display: "inline-flex", verticalAlign: "-1px" }}>
              <Gauge value={thread.quality} label={`содержательность ${thread.quality} из 5`} />
            </span>
          )}
        </p>
      </div>

      {topics.length > 0 && (
        <div className="chips">
          {topics.map((t) => (
            <span key={t.slug} className="chip">
              {t.name}
            </span>
          ))}
        </div>
      )}

      {thread.summary && (
        <Section title="Кратко">
          <div style={{ padding: "12px 16px 14px", fontSize: 14.5, lineHeight: 1.55 }}>
            {thread.summary}
            {thread.question && (
              <p style={{ margin: "12px 0 0" }}>
                <span className="badge">вопрос</span>{" "}
                <span style={{ color: "var(--text-dim)" }}>{thread.question}</span>
              </p>
            )}
            {thread.outcome && (
              <p style={{ margin: "10px 0 0" }}>
                <span className="badge">итог</span>{" "}
                <span style={{ color: "var(--text-dim)" }}>{thread.outcome}</span>
              </p>
            )}
            {thread.tools?.length ? (
              <div className="row-meta">
                {thread.tools.map((t) => (
                  <span key={t} className="badge">
                    {t}
                  </span>
                ))}
              </div>
            ) : null}
          </div>
        </Section>
      )}

      <Section title="Переписка">
        {messages.map((m) => (
          <div key={m.tg_msg_id} className="msg">
            <div
              className="who"
              onClick={() => m.author_id && !m.is_channel && onOpenPerson(m.author_id)}
              style={{ cursor: m.author_id && !m.is_channel ? "pointer" : "default" }}
            >
              {m.author ?? "участник"}
            </div>
            <div className="body">{m.text}</div>
            <div className="when">
              {ruDate(m.ts)}
              {m.reaction_count > 0 &&
                ` · ${plural(m.reaction_count, "реакция", "реакции", "реакций")}`}
            </div>
          </div>
        ))}
      </Section>
    </>
  );
}
